import React from "react";
import { mdiFileExcel } from "@mdi/js";
import Icon from "@mdi/react";
import { Tooltip, Typography, Button } from "@material-ui/core";
import Styled from "styled-components";
import { Wrapper } from "../../Control/Flexbox";
import PrintIcon from "@material-ui/icons/Print";
import formatDate from "../../Control/formatDate";
import { CenteredLogoImg } from "../../../golbalStyles/global.styled";
import TableToExcel from "@dayalk/table-to-excel";
import { images, textInputs } from "../../../constants/constants";

const Table = Styled.table`
	width:98%;
	margin:0.7rem auto;
	 border: 1px solid black;


    th{
        font-size: 13px;
		font-family:"Roboto",sans-serif;
        border: 1px solid black;
        padding: 0.4rem;
        p{
          margin:0;
        }
    }
    td{
        font-size: 13px;
        border: 1px solid black;
        padding: 0.3rem;
        p{
          margin:0;
        }
    }
    span{
        font-weight: 400;
    }
`;
const AAR = ({ ppapData }) => {
  function printTable() {
    var divToPrint = document.getElementById("table-to-xls");
    let newWin = window.open("");
    newWin.document.write(divToPrint.outerHTML);
    newWin.print();
    newWin.close();
  }
  return (
    <section>
      <div className="divflex">
        <Typography
          style={{
            fontSize: "24px",
            fontFamily: "Nunito",
          }}
        >
          APPERANCE APPROVAL REPORT
        </Typography>
        <Wrapper>
          <Tooltip arrow title="Print table">
            <PrintIcon
              style={{
                color: "white",
                cursor: "pointer",
                fontSize: "1.9rem",
                marginRight: "0.6rem",
              }}
              onClick={printTable}
            />
          </Tooltip>
          <Tooltip arrow title="Export as spreadsheet">
            <div>
              <Button
                style={{
                  backgroundColor: "#161a1d",
                  borderColor: "#161a1d",
                  borderRadius: "0",
                  color: "white",
                  width: "fit-content",
                }}
                onClick={() => {
                  TableToExcel.convert(
                    document.getElementById("table-to-xls"),
                    {
                      name: "Appearance Approval Report(AAR).xlsx",
                      sheet: {
                        name: "AAR",
                      },
                    }
                  );
                }}
              >
                <Icon path={mdiFileExcel} size={1.2} />
              </Button>
            </div>
          </Tooltip>
        </Wrapper>
      </div>
      <div style={{ paddingBottom: "4rem" }}>
        <Table
          cellSpacing="0"
          id="table-to-xls"
          data-default-wrap="true"
          data-cols-width="10, 25, 25, 25, 15, 15, 15, 15, 15, 15"
        >
          <thead>
            <tr>
              <th
                colSpan="7"
                align="left"
                rowSpan={4}
                style={{
                  border: "1px solid black",
                  fontSize: "1.6rem",
                  textAlign: "center",
                }}
              >
                <CenteredLogoImg>
                  <img src={images.CompanyLogo} alt={textInputs.companyName} />
                  <span>{textInputs.companyName}</span>
                </CenteredLogoImg>
              </th>
              <th
                align="left"
                colSpan={2}
                style={{ border: "1px solid black" }}
              >
                Format No:
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                F APQP 27
              </th>
            </tr>
            <tr>
              <th
                align="left"
                colSpan={2}
                style={{ border: "1px solid black" }}
              >
                ISSUE DATE:
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                April 19
              </th>
            </tr>
            <tr>
              <th
                align="left"
                colSpan={2}
                style={{ border: "1px solid black" }}
              >
                REVISION NO:
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                00
              </th>
            </tr>
            <tr>
              <th
                align="left"
                colSpan={2}
                style={{ border: "1px solid black" }}
              >
                REVISION DATE:
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                00
              </th>
            </tr>

            <tr>
              <td
                colSpan="10"
                align="center"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  backgroundColor: "#1d1d1d",
                  color: "white",
                  border: "1px solid black",
                }}
                data-font-sz="18"
                data-a-h="center"
                data-f-bold="true"
                data-fill-color="#1d1d1d"
                data-f-color="FFFFFF"
              >
                APPERANCE APPROVAL REPORT
              </td>
            </tr>

            <tr>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Supplier Name: {ppapData.supplier_name}
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Customer Name: {ppapData.customer_name}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Part Name: {ppapData?.part_id?.part_name}
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Date: {formatDate(ppapData.aar_date)}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Part No. : {ppapData?.part_id?.part_number}
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Raw Material / Heat No.: {ppapData.raw_material}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Sample Size: {ppapData.sample_size}
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Drawing No / Standard: {ppapData.drawing_no}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Supplier Code: {ppapData.supplier_code}
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Eng. Level: {ppapData.english_level}
              </td>
            </tr>
            <tr>
              <th
                colSpan={10}
                align="center"
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                REASON FOR SUBMISSION
              </th>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Part Submission Warrant:{" "}
                {ppapData.aar_psw ? (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    ☑
                  </span>
                ) : (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    □
                  </span>
                )}
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Engineering Change:{" "}
                {ppapData.aar_ec ? (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    ☑
                  </span>
                ) : (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    □
                  </span>
                )}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Special Sample:{" "}
                {ppapData.aar_ss ? (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    ☑
                  </span>
                ) : (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    □
                  </span>
                )}
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                First Production Shipment:{" "}
                {ppapData.aar_fpc ? (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    ☑
                  </span>
                ) : (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    □
                  </span>
                )}
              </td>
            </tr>
            <tr>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              >
                Resubmission:{" "}
                {ppapData.aar_resub ? (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    ☑
                  </span>
                ) : (
                  <span
                    style={{
                      fontSize: "1.2rem",
                      marginLeft: "0.6rem",
                    }}
                  >
                    □
                  </span>
                )}
              </td>
              <td
                colSpan={5}
                style={{
                  border: "1px solid black",
                }}
              ></td>
            </tr>
            <tr>
              <th
                colSpan={10}
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                Observation
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th
                align="center"
                rowSpan={2}
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                S NO.
              </th>
              <th
                align="center"
                rowSpan={2}
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                Parameter
              </th>
              <th
                align="center"
                rowSpan={2}
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                Specification
              </th>
              <th
                align="center"
                rowSpan={2}
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                Inspection Method
              </th>
              <th
                align="center"
                colSpan={5}
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                Sample
              </th>
              <th
                align="center"
                rowSpan={2}
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                REMARKS
              </th>
            </tr>
            <tr>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                1
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                2
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                3
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                4
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                5
              </th>
            </tr>
            {ppapData.aars.map((item, index) => (
              <tr key={item._id}>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.s_no}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.parameter}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.specification}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.inspection}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.obs_1}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.obs_2}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.obs_3}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.obs_4}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.obs_5}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.remarks}
                </td>
              </tr>
            ))}
          </tbody>
          <tr height="40" data-height="35">
            <td
              colSpan={10}
              style={{
                border: "1px solid black",
              }}
            >
              Comments: {ppapData?.aar_comment}
            </td>
          </tr>
          <tr>
            <td
              colSpan={5}
              style={{
                border: "1px solid black",
              }}
            >
              Prepared By: {ppapData?.aar_prepared}
            </td>
            <td
              colSpan={5}
              style={{
                border: "1px solid black",
              }}
            >
              Approved By: {ppapData?.aar_approved}
            </td>
          </tr>
        </Table>
      </div>
    </section>
  );
};

export default AAR;
